import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a skill is published (or re-published) to the workspace scope',
  name: 'skill_published_to_workspace',
  params: [
    {
      description: 'ID of the published skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
